class OpCampaign extends HTMLElement {
  constructor() {
    super();
    this.retailerId = this.getAttribute('data-rtl-id');
    if (this.retailerId) {
      this.fetchCampaigns();
    }
  }

  fetchCampaigns() {
    const url = `/apps/ax/order-portal/retailers/${this.retailerId}/campaigns`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        let campaigns = data.campaigns ? data.campaigns : [];
        // campaigns = campaigns.filter(campaign => campaign.productCount > 0);
        this.renderCampaigns(campaigns);
      })
      .catch(error => {
        console.error('Error fetching campaign data:', error);
      });
  }

  renderCampaigns(campaigns) {
    let tableData = [];
    campaigns.forEach(campaign => {
      let completedHtml = campaign.completed ? `<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.3346 1L6.41335 15L1.66797 10.2278" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>` : '';

      let downloadHtml = `<div class="op-download-files flex flex-wrap flex-col" data-id="${campaign.displayId}"></div>`;
      let campaignName = campaign.displayName;
      if (campaign.orderId) {
        campaignName = `<a href="/pages/ordredetaljer?id=${campaign.orderId}" title="">${campaignName}</a>`;
      }
      tableData.push([
        campaignName,
        campaign.displayId,
        campaign.productCount,
        window.convertDateToDanishFormat(campaign.orderFrom),
        window.convertDateToDanishFormat(campaign.orderTo),
        window.convertDateToDanishFormat(campaign.officialFrom),
        window.convertDateToDanishFormat(campaign.officialTo),
        completedHtml,
        downloadHtml
      ]);
    });

    const table = this.querySelector('#op-campaigns-table');
    if (table && tableData.length && typeof table.setRows === 'function') {
      table.classList.remove('hidden');
      table.setRows(tableData);
      this.renderDownloadFiles();
    }
  }

  renderDownloadFiles() {
    this.querySelectorAll('.op-download-files').forEach(item => {
      let id = item.getAttribute('data-id');
      let url = `/pages/${id}/files?view=files`;
      fetch(url)
        .then(response => response.json())
        .then(data => {
          let files = data.length ? data : [];
          let filesHtml = '';
          files.forEach(file => {
            filesHtml += `<a href="${file}" target="_blank"><svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.33203 13.2044L1.33203 16.8925C1.33203 17.4514 1.54275 17.9875 1.91782 18.3827C2.29289 18.778 2.8016 19 3.33203 
                19H15.332C15.8625 19 16.3712 18.778 16.7462 18.3827C17.1213 17.9875 17.332 17.4514 17.332 16.8925V13.2044M9.33315 1V12.9425M9.33315 
                12.9425L13.9046 8.3793M9.33315 12.9425L4.76172 8.3793" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
            </svg></a>`;
          });
          if (filesHtml) {
            item.innerHTML = filesHtml;
          } else {
            item.innerHTML = '';
          }
        }).catch(error => {
          console.error('Error fetching download files:', error);
          item.innerHTML = '';
        });
    })
  }
}

customElements.define('op-campaign', OpCampaign);
